/**
 * EventCountdown pure logic — extracted for unit testing (the AdminPanel
 * pure-helper test convention). No React, no network.
 */

export const TEN_MIN = 10 * 60;
export const TWO_MIN = 2 * 60;

// "DD/MM/YYYY HH:mm" → Date in the device's local timezone (same convention as
// the Swingies/Minimove countdowns — event tablets run on Israel time).
// Structural validation + the NUMERIC Date constructor on purpose: the
// reference implementation's string-built `new Date("undefined-...")` silently
// parses garbage into a 1999 date on some engines (caught by logic.test.js) —
// which would render a scary red "event ended" pill off a malformed endTime.
export const parseEndTime = (raw) => {
  const m = String(raw ?? "")
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4}) (\d{1,2}):(\d{2})$/);
  if (!m) return null;
  const [, day, month, year, hour, minute] = m.map(Number);
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) {
    return null;
  }
  const d = new Date(year, month - 1, day, hour, minute, 0);
  return Number.isNaN(d.getTime()) ? null : d;
};

const pad = (n) => String(n).padStart(2, "0");

export const formatHMS = (totalSeconds) => {
  const s = Math.max(0, totalSeconds);
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = Math.floor(s % 60);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

/**
 * remaining (seconds until the SCHEDULED end; negative = past it) → phase.
 *   calm      > 10 min
 *   warn      2–10 min
 *   critical  0–2 min
 *   overtime  -grace..0   (the photographer's grace window — negative red blink)
 *   ended     < -grace
 */
export const pickPhase = (remaining, graceSec) => {
  if (remaining > TEN_MIN) return "calm";
  if (remaining > TWO_MIN) return "warn";
  if (remaining > 0) return "critical";
  if (remaining > -graceSec) return "overtime";
  return "ended";
};
